module.exports = __webpack_public_path__ + "img/xroad_logo_64_purple.4552b2f2.png";